import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { useProductUrlBrandPage } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductLink/Brand/useProductUrlBrandPage";
import {
  useOnProductClickForBrandPage,
  productClickForBrandPageParametersILeanProductTileAdapter,
} from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickForBrandPage";

/**
 * On brand page, the entire product tile is clickable including white space, therefore this component needs a children attribute.
 */
export const ProductLinkForBrandPage: React.FC<
  React.PropsWithChildren<{
    productTile: ILeanProductTile;
  }>
> = ({ children, productTile }) => {
  const { productUrl } = useProductUrlBrandPage(productTile);
  const onProductClick = useOnProductClickForBrandPage(
    productClickForBrandPageParametersILeanProductTileAdapter(productTile)
  );
  return (
    <ProductLink
      key={`${productTile.product?.token}-product-tile`}
      onClick={onProductClick}
      data-test-id={`product-tile-link-${productTile.product?.token}`}
      to={productUrl}
    >
      {children}
    </ProductLink>
  );
};

const ProductLink = styled(Link)`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;
